export const capitalAllLetters = (string) => {
  if (string) {
    return string.toUpperCase();
  }
};
